import { PageContainer } from '@/components';
import { history } from '@umijs/max';
import { Button, Result } from 'antd';
import React from 'react';

const ForbiddenPage: React.FC = () => (
  <PageContainer>
    <Result
      status='403'
      title='403'
      subTitle='Bạn không có quyền truy cập trang này'
      extra={
        <Button type='primary' onClick={() => history.push('/')}>
          Về trang chủ
        </Button>
      }
    />
  </PageContainer>
);

export default ForbiddenPage;
